import { ModalId } from '@heidi/schema/ml-scribe';

import {
  MODAL_PRIORITY,
  type QueuedModalDescriptor,
} from '../../../dictation-modal-queue-ports';

export const DICTATE_REENGAGEMENT_CARD_MODAL_ID =
  ModalId.ACTION_DICTATED_GENERAL_REENGAGEMENT_POPOVER;

export const DICTATE_REENGAGEMENT_CARD_QUEUE_ITEM: QueuedModalDescriptor = {
  id: DICTATE_REENGAGEMENT_CARD_MODAL_ID,
  priority: MODAL_PRIORITY.HIGH,
  dismissible: true,
  showOnce: true,
};
